<template>
  <div class="flex rounded-xl divide-x divide-gray-300 border border-gray-300 bg-white">
    <span class="pr-4 flex relative">
      <input
        class="rounded-l-xl rounded-r-none px-2 w-14 pr-0 mr-2 ring-none outline-none text-right"
        v-model="newSize"

        @keydown="keydown"
      >
      <span class="absolute top-1/2 -translate-y-1/2 right-0 text-gray-600 block mr-2">px</span>
    </span>

    <span class="flex items-center space-x-1 px-3 cursor-pointer hover:bg-gray-50 duration-150 py-0.5" :class="isMobile && '!text-blue-600 font-semibold'" @click="setSize(390)">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-gray-400" :class="isMobile && '!text-blue-600'" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M7 2a2 2 0 00-2 2v12a2 2 0 002 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zm3 14a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
      </svg>
      <span>Mobile</span>
    </span>
    <span class="flex items-center space-x-1 px-3 cursor-pointer hover:bg-gray-50 duration-150 py-0.5" :class="isTablet && '!text-blue-600 font-semibold'" @click="setSize(770)">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-gray-400" :class="isTablet && '!text-blue-600'" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zm4 14a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
      </svg>
      <span>Tablet</span>
    </span>
    <span class="flex items-center space-x-1 px-3 cursor-pointer hover:bg-gray-50 duration-150 py-0.5" :class="isDesktop && '!text-blue-600 font-semibold'" @click="setSize(1380)">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-gray-400" :class="isDesktop && '!text-blue-600'" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M3 5a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2h-2.22l.123.489.804.804A1 1 0 0113 18H7a1 1 0 01-.707-1.707l.804-.804L7.22 15H5a2 2 0 01-2-2V5zm5.771 7H5V5h10v7H8.771z" clip-rule="evenodd" />
      </svg>
      <span>Desktop</span>
    </span>
    <span class="flex items-center space-x-1 px-3 cursor-pointer hover:bg-gray-50 duration-150 py-0.5" :class="isBigScreen && '!text-blue-600 font-semibold'" @click="setSize(1580)">
      <span class="text-gray-400 flex items-center space-x-1 cursor-pointer hover:bg-gray-50 duration-150 py-0.5" :class="isBigScreen && '!text-blue-600 font-semibold'" @click="setSize(1580)">
        <svg class="w-[13px] h-[13px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" height="600" width="600"><g><rect x="0.5" y="1.5" width="13" height="9" rx="0.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2" stroke-linejoin="round"></rect><path d="M3.53,13.5a3.51,3.51,0,0,1,6.94,0" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></g></svg>
      </span>
      <span class="!ml-2">Big Screen</span>
    </span>
  </div>
</template>

<script>

export default {
  props: ['value'],
  data() {
    return {
      newSize: this.value
    }
  },
  methods: {
    keydown({ key }) {
      if (key === "Enter") {
        this.setSize(this.newSize)
      }
    },
    setSize(number) {
      number = parseInt((number + '').trim())
      if (isNaN(number)) return this.$emit("input", 1380)

      if (number < 340) number = 340
      else if (number > 1600) number = 1600
      this.$emit('input', number)
    },
  },
  computed: {
    isMobile() {
      return this.value < 640
    },
    isTablet() {
      return this.value >= 640 && this.value < 1380
    },
    isDesktop() {
      return this.value >= 1380 && this.value < 1580
    },
    isBigScreen() {
      return this.value >= 1580
    },
  },
  watch: {
    value(val) {
      this.newSize = val
    },
  },
}

</script>
